import { fastchannelPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  { scope: 'Internal.FastChannel', category: 'streaming', route: (id: string) => `${fastchannelPaths.base}/${id}` },
] as const;
